{
  "version": 1,
  "asset_id": "f9486a47-5a9a-44a8-9425-6e2fdc305906",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f9486a47-5a9a-44a8-9425-6e2fdc305906/hiatal-type-4-es-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f9486a47-5a9a-44a8-9425-6e2fdc305906/hiatal-type-4-es-v3-1200.jpg",
  "original_filename": "hiatal-type-4-es-v3-1200.jpg",
  "size": 258395,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:03:37Z"
}
